// extracted by mini-css-extract-plugin
export default {"container":"add-item-skeleton-module__container--iRfBS"};